import UserView from "@/views/user/UserView";
import MyProfileView from "@/views/user/MyProfileView";
import MyProfileEditView from "@/views/user/MyProfileEditView";
import ProfileSettingsView from "@/views/user/ProfileSettingsView";
import { Role } from "@/helpsers/role.helper";
import MyClients from "@/views/user/architect/MyClients";
import UserService from "@/services/user.service";
import ProjectsList from "@/views/user/ProjectsList";
import ProjectSettings from "@/views/user/architect/ProjectSettings";
import UserLayout from "@/layouts/UserLayout";
import { useClientsStore } from "@/stores/user/architect/clients.store";
import { useAuthStore } from "@/stores/auth.store";
import ProjectDetails from "@/views/user/architect/ProjectDetails";
import CreateProjectLayout from "@/layouts/CreateProjectLayout";

import CreateProjectProfile from "@/components/createProject/CreateProjectProfile";
import CreateProjectRooms from "@/components/createProject/CreateProjectRooms";
import CreateProjectFurnitures from "@/components/createProject/CreateProjectFurnitures";
import CreateProjectDeadline from "@/components/createProject/CreateProjectDeadline";
import CreateProjectBudget from "@/components/createProject/CreateProjectBudget";
const Finances = () => import("@/views/user/architect/Finances");

const routes = [
    {
        path: '/my-profile',
        component: UserView,
        beforeEnter: () => {
            const userService = new UserService();
            userService.getUserInfo();
        },
        children: [
            {
                path: '',
                name: 'profile',
                component: MyProfileView,
                meta: {
                    title: 'Profil',
                    authorize: [Role.Architect, Role.Client],
                    layout: UserLayout
                }
            },
            {
                path: 'edit',
                name: '/edit',
                component: MyProfileEditView,
                meta: {
                    title: 'Profil',
                    authorize: [Role.Architect, Role.Client],
                    layout: UserLayout
                }
            },
        ]
    },
    {
        path: '/projects',
        component: UserView,
        children: [
            {
                path: '',
                name: 'projects-list',
                component: ProjectsList,
                beforeEnter: () => {
                    const authStore = useAuthStore();
                    if (authStore.user?.role == Role.Architect) {
                        const clientsStore = useClientsStore();
                        clientsStore.fetchAllClients();
                    }

                    const userService = new UserService();
                    userService.getUserInfo();
                },
                meta: {
                    title: 'Moje Projekty',
                    authorize: [Role.Architect, Role.Client],
                    layout: UserLayout
                },
            },
            {
                path: '/details/:id/:activeTab?/:nestedTab?/:nestedId?',
                name: 'project-details',
                component: ProjectDetails,
                beforeEnter: (to) => {
                    const userService = new UserService();
                    userService.getUserInfo();
                },
                meta: {
                    title: 'Szczegóły projektu',
                    authorize: [Role.Architect, Role.Client],
                    layout: UserLayout
                },
            },
            {
                path: 'settings/:id',
                name: 'project-settings',
                component: ProjectSettings,
                beforeEnter: (to) => {
                    const userService = new UserService();
                    userService.getUserInfo();
                },
                meta: {
                    title: 'Ustawienia projektu',
                    authorize: [Role.Architect, Role.Client],
                    layout: UserLayout,
                }
            },
            {
                path: ':id/create-project-profile',
                name: 'create-project-profile',
                component: CreateProjectProfile,
                beforeEnter: (to) => {
                    const userService = new UserService();
                    userService.getUserInfo();
                },
                meta: {
                    title: 'Tworzenie Projektu',
                    authorize: [Role.Architect],
                    layout: CreateProjectLayout,
                }
            },
            {
                path: ':id/create-project-rooms/:type',
                name: 'create-project-rooms',
                component: CreateProjectRooms,
                beforeEnter: (to) => {
                    const userService = new UserService();
                    userService.getUserInfo();
                },
                meta: {
                    title: 'Tworzenie Projektu',
                    authorize: [Role.Architect],
                    layout: CreateProjectLayout,
                }
            },
            {
                path: ':id/create-project-furnitures',
                name: 'create-project-furnitures',
                component: CreateProjectFurnitures,
                beforeEnter: (to) => {
                    const userService = new UserService();
                    userService.getUserInfo();
                },
                meta: {
                    title: 'Tworzenie projektu',
                    authorize: [Role.Architect],
                    layout: CreateProjectLayout,
                }
            },
            {
                path: ':id/create-project-deadline',
                name: 'create-project-deadline',
                component: CreateProjectDeadline,
                beforeEnter: (to) => {
                    const userService = new UserService();
                    userService.getUserInfo();
                },
                meta: {
                    title: 'Tworzenie projektu',
                    authorize: [Role.Architect],
                    layout: CreateProjectLayout,
                }
            },
            {
                path: ':id/create-project-budget',
                name: 'create-project-budget',
                component: CreateProjectBudget,
                beforeEnter: (to) => {
                    const userService = new UserService();
                    userService.getUserInfo();
                },
                meta: {
                    title: 'Tworzenie projektu',
                    authorize: [Role.Architect],
                    layout: CreateProjectLayout,
                }
            },
        ],
    },
    {
        path: '/my-clients',
        name: 'my-clients',
        component: MyClients,
        beforeEnter: () => {
            const userService = new UserService();
            userService.getUserInfo();
        },
        meta: {
            title: 'Moi klienci',
            authorize: [Role.Architect],
            layout: UserLayout,
        }
    },
    {
        path: '/finances',
        name: 'finances',
        component: Finances,
        beforeEnter: () => {
            const userService = new UserService();
            userService.getUserInfo();
        },
        meta: {
            title: 'Moje finanse',
            authorize: [Role.Architect],
            layout: UserLayout,
        }
    },
    {
        path: '/profile-settings',
        name: 'profile-settings',
        component: ProfileSettingsView,
        beforeEnter: () => {
            const userService = new UserService();
            userService.getUserInfo();
        },
        meta: {
            title: 'Ustawienia',
            authorize: [Role.Architect, Role.Client],
            layout: UserLayout,
        }
    },
]

export default routes;